import {
    FETCH_DIAGNOSIS_LIST_REQUEST,
    FETCH_DIAGNOSIS_LIST_SUCCESS,
    FETCH_DIAGNOSIS_LIST_FAILURE,
  } from "./FetchDiagnosisListTypes";
  import api from "../../utils/Api";
  import axios from 'axios';
  
  export const fetchDiagnosisListRequest = () => {
    return {
      type: FETCH_DIAGNOSIS_LIST_REQUEST,
    };
  };
  
  export const fetchDiagnosisListSuccess = (disciplineList) => {
    return {
      type: FETCH_DIAGNOSIS_LIST_SUCCESS,
      payload: disciplineList,
    };
  };
  
  export const fetchDiagnosisListFailure = (error) => {
    return {
      type: FETCH_DIAGNOSIS_LIST_FAILURE,
      payload: error,
    };
  };
  
  const CancelToken = axios.CancelToken;
  let cancelRequest;
  export const fetchDiagnosisList = (page, payload) => {
   //cancel previous request if multiple hits done.
    cancelRequest && cancelRequest();
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    let url = "medprax/diagnosis/list?pageSize=5&page=" + page;

    if(payload && payload.search_filter && payload.search_key){
      url += "&"+ payload.search_filter+ "=" + payload.search_key;
    }
    return async (dispatch) => {
      dispatch(fetchDiagnosisListRequest);
      try {
        const response = await api.get(
          url,
          {
            headers: headers,
            cancelToken: new CancelToken(function executor(c) {
              cancelRequest = c;
          })
          }
        );
  
        const disciplineList = response.data.data;
        dispatch(fetchDiagnosisListSuccess(disciplineList));
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Error: ', error.message); // => prints: Api is being canceled
        } 
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchDiagnosisListFailure(errorMsg));
      }
    };
  };
  